// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"ProgressBar_progressBarContainer__3OPTl","progressBarFill":"ProgressBar_progressBarFill__0dVIU","percentageText":"ProgressBar_percentageText__B9Zwl"};